import React from 'react'

import { DateTime } from '../../domain/DateTime'
import { TimelineSpan, TimelineSpanParent } from '../../domain/TimelineSpan'
import { getTraceSpanCategory, BottleneckIdentifications, TraceSpanCategory } from '../../domain/Trace'
import { TraceDetailsTitle } from '../tracedetails/TraceDetailsTitle'
import { TraceDetails } from '../tracedetails/TraceDetails'
import TraceDetailsSpan from '../tracedetails/TraceDetailsSpan'

interface OwnProps {
    wt: number
    span: TimelineSpan
    traceInfo?: {
        traceId: string
        isChildTrace: boolean
        serverName: string
        service: string
        environment: string
        measureDate: DateTime
    }
    parents: TimelineSpanParent[]
    categories: { [category: string]: TraceSpanCategory }
    mc?: number
    route: string
    showSettingsLink: boolean
    bottleneckRoute: string
    operationId?: number
    bottleneckIdentifications?: {
        [key: string]: BottleneckIdentifications
    }
    isRoot?: boolean
    children?: React.ReactNode
    sectionBelowTitle?: React.ReactNode
}

type Props = OwnProps

interface State {
    showAllParents: boolean
}

export class Span extends React.Component<Props, State> {
    public static defaultProps = {
        parents: [],
        showSettingsLink: true,
        isRoot: false,
    }

    public state: State = {
        showAllParents: false,
    }

    public blacklist = [
        'repeat_count',
        'repeat_wt',
        'gc',
        'gcc',
        'cwt',
        'cct',
        'query',
        'err_exception',
        'err_source',
        'err_msg',
        'err_trace',
        'cpu',
        'sql',
        'path',
        'service',
        'method',
        'php',
        'php.exit_status',
        'namespace',
        'net.in',
        'net.out',
        'mem',
        'fn',
        'server.cpu_percent',
        'server.mem_percent',
        'server.load_avg',
        'swdal.entity',
        'truncated',
        'sql.params',
        'cmd',
        'http.url',
        'curl.namelookup',
        'curl.connect',
        'curl.appconnect',
        'curl.pretransfer',
        'curl.starttransfer',
        'curl.redirect',
        'graphql.query',
        'm.fio',
        'm.ct',
        'm.al',
        'm.alio',
        'm.alct',
        'm.apcu',
        'xdebug',
        'kafka.payload_size',
        'kafka.topic',
    ]

    public serializeProps() {
        return JSON.stringify({
            wt: this.props.wt,
            span: {
                ...this.props.span,
                e: [],
                events: [],
            },
            traceInfo: this.props.traceInfo,
            stackTrace: this.props.span.stack,
            categories: this.props.categories,
            mc: this.props.mc,
            route: this.props.route,
            showSettingsLink: this.props.showSettingsLink,
            bottleneckRoute: this.props.showSettingsLink,
        })
    }

    public render() {
        const span = this.props.span
        const { isRoot, sectionBelowTitle } = this.props

        return (
            <TraceDetails>
                <TraceDetailsTitle
                    isRoot={isRoot || false}
                    category={getTraceSpanCategory(span)}
                    name={span.name}
                    namespace={span.annotations?.namespace || undefined}
                />
                {sectionBelowTitle}
                <TraceDetailsSpan
                    wt={this.props.wt}
                    mc={this.props.mc}
                    span={span}
                    categories={this.props.categories}
                    parents={this.props.parents}
                    route={this.props.route}
                    showSettingsLink={this.props.showSettingsLink}
                    bottleneckRoute={this.props.bottleneckRoute}
                    traceInfo={this.props.traceInfo}
                />
                {this.props.children}
            </TraceDetails>
        )
    }
}

export default Span
